"use client"

import { Box, Button, Checkbox, Container, Dialog, DialogActions, Divider, FormControlLabel, FormGroup, IconButton, MenuItem, Paper, Stack, TextField, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { useParams, useRouter } from "next/navigation";
import { useEffect, useState } from "react";
import Loading from "./LoadingScreen";
import Image from "next/image";
import { GCpublicUrl, publicBucketName } from "@/lib/googlecloud";
import { Close, Delete, Error, Phone, West } from "@mui/icons-material";
import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import SuccessfulScreen from "./SuccessfulScreen";
import dayjs from "dayjs";
import { useSession } from "next-auth/react";

export default function LocationBookingForm() {

    const {data: session} = useSession();
    const router = useRouter();

    const [isLoading, setIsLoading] = useState(true)
    const [location, setLocation] = useState()
    const [error, setError] = useState("")

    // FORM STATES
    const [bookingOpen, setBookingOpen] = useState(false)
    const [next, setNext] = useState(false)
    const [submitting, setSubmitting] = useState(false)
    const [success, setSuccess] = useState("")

    // PATIENT DETAILS
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [birthday, setBirthday] = useState("")
    const [sex, setSex] = useState("")
    const [allergies, setAllergies] = useState("")
    const [comorbidities, setComorbidities] = useState("")
    const [phone, setPhone] = useState("")
    const [email, setEmail] = useState("")

    const [visitTimeDate, setVisitTimeDate] = useState()

    const [forLabs, setForLabs] = useState(false)
    const [forConsult, setForConsult] = useState(false)
    const [forImaging, setForImaging] = useState(false)

    const [labList, setLabList] = useState([""])
    const [chiefComplaint, setChiefComplaint] = useState("")
    const [otherNotes, setOtherNotes] = useState("")
    
    const {locationId} = useParams();

    const handleSubmit = async () => {
        setSubmitting(true)

        if (!location || !locationId) {
            setSubmitting(false)
            return
        } 

        // if (labList.includes(lab => "")) {
        //     handleError("Please select lab test/s to be done.")
        // }

        else {
            try {

                const res = await fetch("/api/addScheduled", {
                    method: "POST",
                    body: JSON.stringify({
                        locationId: locationId,
                        locationName: location.locationName,
                        patientFirstName: firstName,
                        patientLastName: lastName,
                        patientBirthday: birthday,
                        patientSex: sex,
                        patientAllergies: allergies,
                        patientComorbidities: comorbidities,
                        patientPhone: phone,
                        patientEmail: email ,
                        visitTimeDate: visitTimeDate,
                        email: email,
                        chiefComplaint,
                        otherNotes,
                        forLabs: forLabs,           
                        forConsult: forConsult,  
                        forImaging: forImaging,  
                        // labRequests: labList,    FOR DEPRECATION 02/24/2025

                    })
                })

                const createdSchedule = await res.json()

                if (createdSchedule) {
                    setSubmitting(false)
                    setSuccess(
                        `Scheduled visit created.
                        Ref: ${createdSchedule._id}
                        Date and Time: ${dayjs(createdSchedule.visitTimeDate).format("LLL")}
                        `
                    )

                } else {
                    setSubmitting(false)
                    handleError("error in submitting please try again.")
                }

            }
            catch (error) {
                setSubmitting(false)
                handleError(`Error in scheduling visit: ${error}`)
            }


        }
    }

    const getLocation = async () => {
        try {
            const res = await fetch("/api/getLocation",{
                method: "POST",
                body: JSON.stringify({_id: locationId})
            })

            const location = await res.json()

            setLocation(location);
            setIsLoading(false);
        } catch (error) {
            console.log(`ERROR in location booking form: ${error}`)
        }
    }

    const nextHandler = () => {
        if (!firstName || !lastName) {
            handleError("Input your name(s)")
            return
        } 
        if (!birthday) {
            handleError("Please input birthday")
            return
        } 
        if (!phone) {
            handleError("please input your phone number")
            return
        } 
        else {
            setNext(true)
        }
    }

    const handleError = (message) => {
        setError(message);
        setTimeout(() => {
            setError("")
        }, 2000);
    }

    const handleLabsAdd = () => {
        const newLabAdd = [...labList, ""]

        setLabList(newLabAdd)
    }

    const handleLabedit = (e, index) => {
        const {value} = e.target
        const newLabs = labList.map((lab, i) => {
            if (i === index) {
                return value
            } else {
                return lab
            }
        })

        setLabList(newLabs)
    }

    const handleLabDelete = (index) => {
        const newLabs = labList.filter((s, i) => index != i);

        setLabList(newLabs)
    }

    useEffect(() => {
        getLocation()
    }, [])

    const ProtectedButton = () => {
        if (session) return (
            <Button color="secondary" variant="text" onClick={() => {router.replace("/")}}>Return to Dashboard</Button>
        )
    }

    if (isLoading) return (
        <main className="h-screen grid place-items-center">
            <Loading />
        </main>
    )

    if (!isLoading && location) return (
        <main className="h-screen grid place-items-center p-5">
            <Paper elevation={6} sx={{padding: 5}}>
                <Container>
                    <Stack gap={3} alignItems={"center"}>
                        {(location.locationLogo) &&
                            <Box component={"img"} src={`${GCpublicUrl}/${publicBucketName}/${location.locationLogo}`} sx={{height: 100, bgcolor: "white", padding: 2, borderRadius: 3}} />
                        }
                        <Stack gap={1} alignItems={"center"}>
                            <Typography>Welcome to</Typography>
                            <Typography fontSize={"large"} sx={{fontWeight: 700}}>{location.locationName}</Typography>
                            <Typography>{location.locationAddress}</Typography>
                        </Stack>
                        <Button onClick={() => {setBookingOpen(true)}}>Schedule Visit</Button>
                        <ProtectedButton />
                    </Stack>
                </Container>
            </Paper>


            {/* DIALOGS */}
            <Dialog
            open={bookingOpen && !next}
            onClose={() => (setBookingOpen(false))}
            fullWidth
            >
                <DialogActions>
                    <IconButton color="error" onClick={() => (setBookingOpen(false))}><Close /></IconButton>
                </DialogActions>
                <Paper sx={{padding: 2}}>
                    <Stack gap={2}>
                        <Typography>Patient Details</Typography>
                        <TextField value={firstName} onChange={(e) => {setFirstName(e.target.value)}} label="First Name" required />
                        <TextField value={lastName} onChange={(e) => {setLastName(e.target.value)}} label="Last Name" required />
                        <ToggleButtonGroup exclusive>
                            <ToggleButton selected={sex === "male"} value={"male"} onClick={(e) => {setSex(e.target.value)}}>Male</ToggleButton>
                            <ToggleButton selected={sex === "female"} value={"female"} onClick={(e) => {setSex(e.target.value)}}>Female</ToggleButton>
                        </ToggleButtonGroup>
                        <DatePicker value={birthday} onChange={(e) => {setBirthday(e)}} label="Birthday" required />
                        <TextField value={allergies} onChange={(e) => {setAllergies(e.target.value)}} label="Allergies" />
                        <TextField value={comorbidities} onChange={(e) => {setComorbidities(e.target.value)}} label="Comorbidities" />
                        <TextField value={phone} onChange={(e) => {setPhone(e.target.value)}} label="Phone No." required />
                        <TextField value={email} onChange={(e) => {setEmail(e.target.value)}} label="Email" />
                        <Button onClick={() => {nextHandler()}}>Next</Button>
                    </Stack>
                </Paper>
            </Dialog>

            <Dialog
            open={bookingOpen && next}
            onClose={() => (setBookingOpen(false))}
            fullWidth
            >
                <DialogActions>
                        <IconButton color="primary" onClick={() => (setNext(false))}><West /></IconButton>
                        <IconButton color="error" onClick={() => (setBookingOpen(false))}><Close /></IconButton>
                </DialogActions>
                <Paper sx={{padding: 2}}>
                    <Stack gap={2}>
                        {/* <Typography>Lab Requests</Typography> */}
                        <DateTimePicker  label="Preferred Visit Date and Time" value={visitTimeDate} onChange={(e) => setVisitTimeDate(e)} />
                        {/* <Stack direction={"row"} gap={3}>
                            <Stack direction={"row"} alignItems={"center"}>
                                <Checkbox name="forLabs" checked={forLabs} onChange={() => setForLabs(!forLabs)}/>
                                <Typography>For Laboratory Tests</Typography>
                            </Stack>
                        </Stack> */}
                        {/* <Stack gap={1}>
                            {labList.map((singleLab, index) => (
                                <Stack direction={"row"} justifyContent={"space-between"} gap={1}>
                                    <TextField key={index} value={singleLab} label={`Lab Test #${index + 1}`} sx={{width: 1}} select onChange={(e) => {handleLabedit(e, index)}}>
                                    {location.packagesCatalog.map((packageCatalog, index) => (
                                        <MenuItem key={index} value={packageCatalog.name}>
                                        {packageCatalog.name} - {packageCatalog.inclusions.join(", ")} - ₱{packageCatalog.price}
                                        </MenuItem>
                                        ))}
                                        <Divider />
                                        {location.labsCatalog.map((labCatalog, index) => (
                                            <MenuItem key={index} value={labCatalog.name}>
                                            {labCatalog.name} - ₱{labCatalog.price}
                                            </MenuItem>
                                            ))}
                                            </TextField>
                                            {(index > 0) &&
                                            <Button variant="text" color="error" onClick={() => handleLabDelete(index)}><Delete /></Button>
                                            }
                                            </Stack>
                                            ))}
                                            </Stack> */}
                        {/* <div><Button onClick={() => handleLabsAdd()}>Add Lab Tests</Button></div> */}
                        {/* <Stack direction={"row"} alignItems={"center"}>
                            <Checkbox name="forConsult" checked={forConsult} onChange={() => setforConsult(!forConsult)} />
                            <Typography>Schedule Consult with Physician?</Typography>
                            </Stack> */}
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={forLabs} onClick={() => {setForLabs(!forLabs)}} />} label="Schedule Lab Test" />
                            <FormControlLabel control={<Checkbox checked={forConsult} onClick={() => {setForConsult(!forConsult)}} />} label="Schedule Consult" />
                            <FormControlLabel control={<Checkbox checked={forImaging} onClick={() => {setForImaging(!forImaging)}} />} label="Schedule Imaging (X-Ray)" />
                        </FormGroup>
                        <TextField value={chiefComplaint} label="Reason for Visit" onChange={(e) => {setChiefComplaint(e.target.value)}} />
                        <TextField value={otherNotes} label="Lab Request/Other Notes/Description" onChange={(e) => {setOtherNotes(e.target.value)}} />
                        <Button onClick={() => {handleSubmit()}}>Submit</Button>
                    </Stack>
                </Paper>
            </Dialog>

            <Dialog
            open={error}
            >
                <Paper sx={{padding: 5}}>
                    <Stack direction={"row"} alignItems={"center"} gap={1}>
                        <Error color={"error"} />
                        <Typography color={"error"}>{error}</Typography>
                    </Stack>
                </Paper>
            </Dialog>

            <Dialog
            open={success}
            >
                <Stack>
                    <SuccessfulScreen message={success} />
                    <ProtectedButton />
                </Stack>
            </Dialog>


        </main>
    )
}